import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const marques = [
  { name: "Somfy", desc: "Moteurs io, RTS, filaires et commandes" },
  { name: "Simu", desc: "Moteurs tubulaires et accessoires" },
  { name: "Bubendorff", desc: "Moteurs radio et commandes" },
  { name: "Profalux", desc: "Moteurs et groupes de commande" },
  { name: "Elero", desc: "Motorisation radio et filaire" },
  { name: "Selve", desc: "Moteurs tubulaires et commandes" },
];

export default function AutresMarques() {
  return (
    <section className="bg-[#F4F8FB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/9ac26fd9cfc8ea7d3316250a374a313b.jpeg"
              alt="Technicien intervenant sur différentes marques de moteurs de volet roulant à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
          <div>
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Les autres marques que nous traitons
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Nice est particulièrement apprécié sur les grandes baies vitrées et les volets lourds grâce à la robustesse de ses moteurs tubulaires. Mais les logements du Bas-Rhin utilisent aussi des Somfy, Simu, Bubendorff et Profalux. Nous remplaçons régulièrement des moteurs de ces marques avec la même rigueur que pour les Nice. La différence technique réside surtout dans les protocoles de commande : Somfy utilise io et RTS, Nice le OXIBD, Bubendorff une radio propriétaire, et Profalux des fils conducteurs dans les lames.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Notre stock de pièces de rechange est organisé par type de panne plutôt que par marque : condensateurs, récepteurs radio, télécommandes, moteurs tubulaires. Nous disposons d'une salle de test où chaque moteur reconditionné est vérifié avant livraison. Si vous avez un doute sur la marque de votre moteur, nous l'identifions sur place en quelques minutes. Pas besoin de connaître le modèle exact : nous le trouvons, nous le diagnostiquons, nous le remplaçons.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8">
              {marques.map((marque) => (
                <div
                  key={marque.name}
                  className="bg-white rounded-xl border border-[#E2E8F0] p-4 md:p-5 text-center hover:border-[#00B3A4]/40 transition-colors"
                >
                  <p className="text-[#143A66] font-bold text-base mb-1">{marque.name}</p>
                  <p className="text-[#2F4A63] text-xs">{marque.desc}</p>
                </div>
              ))}
            </div>
            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}